import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from '../../../common/components/runtime-context';
import classNames from 'classnames';
import Masonry from 'react-masonry-component';
import withDirection, { withDirectionPropTypes, DIRECTIONS } from 'react-with-direction';
import { CARD_SIZE_SMALL, CARD_SIZE_MEDIUM, CARD_SIZE_LARGE } from '../../constants/card-sizes';
import { CARD_SIZE_PATH } from '../../constants/wix-params';
import PostListItem from '../post-list-item';
import { isSeo } from '../../../common/store/basic-params/basic-params-selectors';
import withAppSettings from '../../hoc/with-app-settings';
import styles from './post-list.scss';
import { SortingSelectCategoryPageDesktop } from '../sorting-select-category';
import CreatePostButton from '../create-post-button/create-post-button';

const TYPES = {
  [CARD_SIZE_SMALL]: 'small',
  [CARD_SIZE_MEDIUM]: 'medium',
  [CARD_SIZE_LARGE]: 'large',
};

const MASONRY_OPTIONS = {
  transitionDuration: 0,
  fitWidth: false,
  gutter: 20,
};

const buildMasonryOptions = ({ direction }) => ({
  ...MASONRY_OPTIONS,
  originLeft: direction === DIRECTIONS.LTR,
});

const renderCreateNewPostButton = category => {
  return <CreatePostButton categorySlug={category.slug} isSmall />;
};

const renderSortingSelect = () => {
  return (
    <div className={styles.sortSelectContainer}>
      <SortingSelectCategoryPageDesktop />
    </div>
  );
};

const Controls = ({ category, showCreatePostAction }) => {
  return (
    <div className={classNames(styles.controls)}>
      {renderSortingSelect()}
      {showCreatePostAction && renderCreateNewPostButton(category)}
    </div>
  );
};

Controls.propTypes = {
  category: PropTypes.object,
  showCreatePostAction: PropTypes.bool,
};

const PostListMasonry = ({
  direction,
  category,
  posts,
  cardSize,
  onLikeClick,
  showCreatePostAction,
  showCategoryLink,
  isSeo,
}) => {
  const type = TYPES[cardSize];
  const className = classNames(styles.masonry, styles[type]);
  return (
    <div>
      <Controls category={category} showCreatePostAction={showCreatePostAction} />
      <Masonry
        className={className}
        options={buildMasonryOptions({ direction })}
        data-hook="post-list"
      >
        {posts.map(post => (
          <div
            className={classNames(
              styles.listItem,
              { [styles.listItemSeo]: isSeo },
              'post-list__post-list-item',
            )}
            key={post._id}
            id={post._id}
            data-hook="post-list-item"
          >
            <PostListItem
              type={type}
              post={post}
              onLikeClick={onLikeClick}
              showCategoryLink={showCategoryLink}
            />
          </div>
        ))}
      </Masonry>
    </div>
  );
};

PostListMasonry.propTypes = {
  ...withDirectionPropTypes,
  onLikeClick: PropTypes.func.isRequired,
  category: PropTypes.object,
  posts: PropTypes.array,
  query: PropTypes.string,
  cardSize: PropTypes.number,
  showCreatePostAction: PropTypes.bool,
  showCategoryLink: PropTypes.bool,
  isSeo: PropTypes.bool,
};

PostListMasonry.defaultProps = {
  cardSize: CARD_SIZE_MEDIUM,
};

const mapRuntimeToProps = state => ({
  isSeo: isSeo(state),
});

export default flowRight(
  connect(mapRuntimeToProps),
  withAppSettings({
    cardSize: CARD_SIZE_PATH,
  }),
  withDirection,
)(PostListMasonry);
